export default __webpack_public_path__ + "static/media/pindos-remove.5fbdb5ff.png";